


import { Component, Vue } from "vue-property-decorator";

import { Account } from "App";

import Ocean from "Web/Components/Common/Ocean.vue";

/* Public "forgot password" page. Reuses the shared .v-activate auth-card styles (defined globally
   by the Activate view). The confirmation is shown whatever the address, so the page never reveals
   whether an account exists. */
@Component({
    components: {
        Ocean
    }
})
export default class ForgotPasswordView extends Vue {
    private email: string = "";

    private busy: boolean = false;
    private sent: boolean = false;
    private error: string = "";

    private get canSubmit(): boolean {
        return this.email.trim() !== "";
    }

    private async submit(): Promise<void> {
        if( this.busy || !this.canSubmit )
            return;

        this.busy = true;
        this.error = "";

        const error = await Account.ForgotPassword( this.email.trim() );

        this.busy = false;

        if( error !== undefined ) {
            this.error = error.Message;
            return;
        }

        this.sent = true;
    }
}
